import { AwardJudge } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getCountryAwardJudges: (
  fetchContext: FetchContext,
  awardId: number,
  countryId: number,
  accessToken?: string,
) => Promise<AwardJudge[]> = (fetchContext, awardId, countryId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/country/${countryId}/judges`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<AwardJudge[]>(fetchContext.errorStore, response, 'get country award judges'));